import React, { useState } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import BaseFilter, {
  FilterTypeEnum,
} from 'components/base/BaseFilter';
import { ArrayStringData } from 'utils';
import { tierTypeConfig } from 'config/TierTypeConfig';

function Filter({ backAction = () => {} }) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search);
  const searchType = parsedSearch['type'] || '';
  const searchStatus = parsedSearch['status'] || '';
  const searchExpiryDate = parsedSearch['expiry_date'] || '';
  const searchCreationPeriod = parsedSearch['create_date'] || '';

  const [type, setType] = useState(searchType);
  const [status, setStatus] = useState(
    ArrayStringData(searchStatus),
  );
  const [expiryDate, setExpiryDate] = useState(searchExpiryDate);
  const [creationPeriod, setCreationPeriod] = useState(searchCreationPeriod);

  const content = [
    {
      hide: !tierTypeConfig.onlineStore,
      title: 'Type',
      data: [
        { name: 'Virtual', pk: 'VIRTUAL' },
        { name: 'Physical', pk: 'PHYSICAL' },
      ],
      value: type,
      setValue: setType,
      component: FilterTypeEnum.singleChoice,
    },
    {
      title: 'Status',
      data: [
        { name: 'Generated', pk: 'GENERATED' },
        { name: 'Customer online purchased', pk: 'PURCHASED' },
        { name: 'Customer used', pk: 'USED' },
        { name: 'Admin edited', pk: 'EDITED' },
        { name: 'Refunded', pk: 'REFUNDED' },
      ],
      value: status,
      setValue: setStatus,
      component: FilterTypeEnum.choice,
    },
    {
      title: 'Expiry date',
      data: [
        { name: 'All time', pk: 'ALL_TIME' },
        { name: 'Time Range', pk: 'IN_PERIOD' },
        { name: 'Since acquiring', pk: 'DAYS_SINCE_ACQUIRE' },
      ],
      value: expiryDate,
      setValue: setExpiryDate,
      component: FilterTypeEnum.singleChoice,
    },
    {
      title: 'Create date',
      value: creationPeriod,
      setValue: setCreationPeriod,
      component: FilterTypeEnum.dateRange,
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

export default Filter;
